module.exports = __webpack_public_path__ + "img/john-carr.a3537e79.jpg";